"use strict";
// Available provider keys
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinchProviderKeySchema = void 0;
const zod_1 = require("zod");
/**
 * https://developer.tryfinch.com/integrations/providers
 */
exports.FinchProviderKeySchema = zod_1.z.enum([
    'justworks',
    'trinet',
    'quickbooks',
    'adp_run',
    'adp_workforce_now',
    'ceridian_dayforce',
    'paychex_flex',
    'paylocity',
    'workday',
    'zenefits',
]);
